import { ActionTypesFactory } from "../../config/helper";

export const Customers = ActionTypesFactory("Admin", "Customers");
export const SyncOmniData = ActionTypesFactory("Admin", "SyncOmniData");
export const Customer = ActionTypesFactory("Admin", "Customer");
export const GetProdsFromExcel = ActionTypesFactory("Admin", "ProdsFromExcel");
export const UploadExcel = ActionTypesFactory("Admin", "UploadExcel");
export const Products = ActionTypesFactory("Admin", "Products");
export const Origins = ActionTypesFactory("Admin", "Origins");
export const UploadProdImg = ActionTypesFactory("Admin", "UploadProdImg");
export const Orders = ActionTypesFactory("Admin", "Orders");
export const Marketing = ActionTypesFactory("Admin", "Marketing");
export const GetMarketing = ActionTypesFactory("Admin", "GetMarketing");

export const get_customers = (payload) => {
  return {
    type: Customers.REQUEST,
    payload,
  };
};

export const marketing = (payload) => {
  return {
    type: Marketing.REQUEST,
    payload,
  };
};

export const get_marketing = (payload) => {
  return {
    type: GetMarketing.REQUEST,
    payload,
  };
};

export const sync_omni_data = (payload) => {
  return {
    type: SyncOmniData.REQUEST,
    payload,
  };
};

export const get_customer = (payload) => {
  return {
    type: Customer.REQUEST,
    payload,
  };
};

export const upload_excel = (payload) => {
  return {
    type: UploadExcel.REQUEST,
    payload,
  };
};

export const get_prods_excel = (payload) => {
  return {
    type: GetProdsFromExcel.REQUEST,
    payload,
  };
};

export const upload_product_img = (payload) => {
  return {
    type: UploadProdImg.REQUEST,
    payload,
  };
};

export const get_products = () => {
  return {
    type: Products.RESET,
  };
};

export const get_origins = () => {
  return {
    type: Origins.REQUEST
  };
};

export const get_orders = (payload) => {
  return {
    type: Orders.REQUEST,
    payload,
  };
};
